import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CREHANA_DIPLOMAS_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, CREHANA_DIPLOMAS_TRANSLATION_KEY, {
  DIPLOMAS_TITLE: 'Seus diplomas',
  VER_TUDO: 'Ver todos',
  EMPTY_VIEW_TITLE: 'Aún no obtienes tu diplomas o certificado de participação.',
  EMPTY_VIEW_DESC: 'Para obter um diploma deberás culminar uma rota de Academia y para obter certificados de participação de Crehana solo debes terminar el 100% de visualização de tus classes.',
  EMPTY_VIEW_BUTTON: 'Ir a mis cursos',
  EMPTY_VIEW_BUTTON_PROJECT: 'Ir a mís projetos',
  EMPTY_VIEW_DEGREE_DESC: 'Uma vez que completes todos os cursos e contratados tus proyectos parciais, tendendo a avanzar o proyecto final e aprobarlo para poder obter o diploma de MicroDegree.',
  EMPTY_VIEW_DEGREE_BUTTON: 'Ir a mi MicroDegree',
  DOWNLOAD_FILTER: 'Tipo de certificação',
  DOWNLOAD_FILTER_ALL: 'Todos ({{count}})',
  DOWNLOAD_FILTER_DIPLOMA: 'Diplomas ({{count}})',
  DOWNLOAD_FILTER_PROOF: 'Certificados ({{count}})',
  DOWNLOAD_DIPLOMA: 'DIPLOMA',
  DOWNLOAD_PROOF: 'CONSTÂNCIA',
  DOWNLOAD_DESCRIPTION_GENERAL: 'En total lograste {{diplomasCount}} diplomas e {{certificateCount}} constâncias de participação'
});